import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pause\"><path fill-rule=\"evenodd\" d=\"M6 19h4V5H6v14Zm8-14v14h4V5h-4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol